export const subscriptionPlanTypes = {
  FREE: 'FREE',
  PRO: 'PRO',
  PLUS: 'PLUS',
  ENTERPRISE: 'ENTERPRISE'
};

export const subscriptionBlockerType = {
  FULL: 'Full',
  PARTIAL: 'Partial'
};
